import { Link } from "react-router-dom";
import { ArrowUpRight, TrendingDown, PiggyBank } from "lucide-react";
import { SERVICES } from "../data/content";

export default function ServicesGrid() {
  return (
    <section data-testid="services-section" id="services" className="relative section-padding bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <div className="eyebrow">Nos services</div>
            <h2 className="font-display uppercase text-white text-4xl md:text-6xl mt-4 leading-[0.95] tracking-tight">
              Des solutions<br/>
              <span className="text-[#7DD923]">rentables</span> et durables
            </h2>
          </div>
          <p className="text-white/60 max-w-md text-base leading-relaxed">
            Chaque projet est unique. Nous étudions votre logement et vos revenus pour proposer la solution la plus rentable, avec un maximum d'aides.
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-6 gap-4 md:gap-5">
          {SERVICES.map((s, idx) => {
            const layout = [
              "md:col-span-4 md:row-span-2",
              "md:col-span-2 md:row-span-2",
              "md:col-span-2",
              "md:col-span-2",
              "md:col-span-2",
            ][idx] || "md:col-span-2";
            const isLarge = idx === 0 || idx === 1;
            return (
              <Link
                key={s.slug}
                to={`/services#${s.slug}`}
                data-testid={`service-card-${s.slug}`}
                className={`group relative overflow-hidden rounded-2xl border border-white/5 bg-[#121212] hover:border-[#7DD923]/40 transition-all duration-500 ${layout} ${isLarge ? "min-h-[380px]" : "min-h-[240px]"}`}
              >
                <img
                  src={s.image}
                  alt={s.title}
                  className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:opacity-60 group-hover:scale-105 transition-all duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-black/20" />
                <div className="relative z-10 h-full flex flex-col justify-between p-6 md:p-8">
                  <div>
                    <div className="text-xs uppercase tracking-[0.25em] text-[#7DD923] font-bold">{s.tagline}</div>
                    <h3 className={`font-display uppercase text-white mt-3 tracking-tight leading-tight ${isLarge ? "text-3xl md:text-4xl" : "text-2xl"}`}>{s.title}</h3>
                  </div>

                  <div>
                    {isLarge && (
                      <ul className="space-y-1.5 mb-6 max-w-md">
                        {s.benefits.slice(0,3).map((b) => (
                          <li key={b} className="text-white/70 text-sm flex items-start gap-2">
                            <div className="w-1.5 h-1.5 rounded-full bg-[#7DD923] mt-2 flex-shrink-0" /> {b}
                          </li>
                        ))}
                      </ul>
                    )}
                    <div className="flex flex-wrap items-center gap-4 pt-4 border-t border-white/10">
                      <div className="flex items-center gap-1.5 text-xs text-white/80">
                        <TrendingDown className="w-3.5 h-3.5 text-[#7DD923]" /> {s.savings}
                      </div>
                      <div className="flex items-center gap-1.5 text-xs text-white/80">
                        <PiggyBank className="w-3.5 h-3.5 text-[#7DD923]" /> {s.aides}
                      </div>
                      <ArrowUpRight className="w-4 h-4 text-white/60 group-hover:text-[#7DD923] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all ml-auto" />
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
